<template>
  <div class="expiration_date">
    <span>{{ props.expiration_text }}:</span>
    <div class="two-column">
      <div class="form-group">
        <div class="custom-selectt">
          <select
            id="cc_exp_month"
            v-model="card_exp_month"
            @change="emit('change-month', card_exp_month)"
            class="form-control"
            name="cc_exp_month"
            autocomplete="cc-exp-month"
            :class="{'error': props.validMonth.$errors.length }"
          >
            <option :value="null">{{ props.month_text }}</option>
            <option value="01">01</option>
            <option value="02">02</option>
            <option value="03">03</option>
            <option value="04">04</option>
            <option value="05">05</option>
            <option value="06">06</option>
            <option value="07">07</option>
            <option value="08">08</option>
            <option value="09">09</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <div class="custom-selectt">
          <select
            id="cc_exp_year"
            v-model="card_exp_year"
            @change="emit('change-year', card_exp_year)"
            class="form-control"
            name="cc_exp_year"
            autocomplete="cc-exp-year"
            :class="{'error': props.validYear.$errors.length }"
          >
            <option :value="null">{{ props.year_text }}</option>
            <option :value="year" v-for="year in years" :key="year">{{ year }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { years } from './fields.js'

const props = defineProps({
  expiration_text: String,
  month_text: String,
  year_text: String,
  validYear: Object,
  validMonth: Object
})

const emit = defineEmits(['change-month', 'change-year'])

const card_exp_month = ref(null)
const card_exp_year = ref(null)
</script>

<style scoped>
select {
  height: 43px;
}
</style>
